require('prototype-extensions/js/DomExtensions');
const Ppm = {
        /**
         *
         * @param e event kliknięcia
         * @param vars
         * @param lvl poziom zaglębienia (w menu wielopoziomowym)
         * @param posX
         * @param posY
         */
        show: function (e, vars, lvl = 0, posX = null, posY = null) {
            this.hideByLvl(lvl);

            let _this = this;
            let ppmMenu = document.create('div', {classList: ['ppmContainer', ['text-nowrap']]});
            ppmMenu.lvl = lvl;
            let ppmMenuList = ppmMenu.add('ul');

            for (let item of vars) {
                if (item.ico == undefined)
                    item.ico = '';
                let elem = ppmMenuList.add('li', {});
                elem.add('i', {classList: ['material-icons'], text: item.ico});
                if (item.disabled) elem.classList.add('disabled');
                if (item.color) elem.style.color = item.color;
                if (item.html)
                    elem.add('span', {html: item.html});
                else
                    elem.add('span', {text: item.text});
                if (item.sub && item.sub.length) {
                    elem.add('i', {classList: ['material-icons', 'float-right'], text: 'arrow_right'});
                    elem.sub = item.sub;//podmenu po najechaniu
                }
                if (item.data) {
                    Object.assign(elem.dataset, item.data);
                }
                if (item.className) {
                    elem.className = vars[i].className;
                }
                elem.func = item.func;
                elem.funcMousedown = item.funcMousedown;
                elem.lvl = lvl;
                elem.ppmVars = item;

                elem.onclick = (e) => {
                    if (item.disabled) return;
                    if (item.func) {
                        item.func.call(elem, e);
                        this.hide(ppmMenu);
                    }
                };
                elem.onmousedown = e => {
                    if (item.disabled) return;
                    if (item.funcMousedown) {
                        let ret = item.funcMousedown.call(elem, e);
                        if (ret) {
                            this.hide(ppmMenu);
                        }
                    }
                };
                elem.onmouseover = e => {
                    if (elem.sub) {
                        this.show(e, elem.sub, lvl + 1, $(elem).parent().offset().left + $(elem).parent().width(), $(elem).offset().top - 1 - scrollY);
                    } else {
                        this.hideByLvl(lvl + 1);
                    }
                };
            }
            document.body.appendChild(ppmMenu);

            if (posX === null) {
                posX = e.clientX;
                posY = e.clientY;
            }

            let leftMax = innerWidth - ppmMenu.offsetWidth;//żeby nie wychodziło za ekran
            let topMax = innerHeight - ppmMenu.offsetHeight;//żeby nie wychodziło za ekran
            ppmMenu.style.top = Math.min(posY, topMax) + 'px';
            ppmMenu.style.left = Math.min(posX, leftMax) + 'px';


            $(window).on('click scroll', function () {
                _this.hide(ppmMenu);
            });
            $('.perfect-scrollbar').on('scroll', function () {
                _this.hide(ppmMenu);
            });

        },
        hide: function (ppmMenu) {
            if (!ppmMenu) {
                ppmMenu = $('body').find('.ppmContainer')[0];
            }
            ppmMenu.remove();
        },
        hideByLvl: function (lvl) {
            let $ppmMenu = $('body').find('.ppmContainer')
            for (let i = 0; i < $ppmMenu.length; i++) {
                if ($ppmMenu[i].lvl >= lvl)
                    $ppmMenu.eq(i).remove();
            }
        }
    }
;

export default Ppm;